import React from "react";
import { postExpense } from "../services/api";

const AddExpense = ({
  categories,
  setDescription,
  category,
  amount,
  description,
  setAmount,
  setCategory,
  account,
  expensesThisMonth,
  setExpensesThisMonth,
  month,
  year,
  setExpensesPaginated,
}) => {
  const addExpense = () => {
    if (!amount || !category) {
      alert("Please fill in the amount and category fields");
      return;
    }
    const currentTimestamp = new Date().toLocaleDateString();
    postExpense({
      account,
      category,
      amount,
      description,
      date: currentTimestamp,
    })
      .then((response) => {
        setExpensesThisMonth([...expensesThisMonth, response.data]);
        if (
          month === new Date().getMonth() + 1 &&
          year === new Date().getFullYear()
        ) {
          setExpensesPaginated([...expensesThisMonth, response.data]);
        }
        setCategory("");
        setAmount("0");
        setDescription("");
        alert("Expense Added");
      })
      .catch((error) => console.error(error));
  };

  const handleButtonClick = (value) => {
    if (value === "backspace") {
      if (amount.length === 1) {
        setAmount("0");
      } else {
        setAmount(amount.slice(0, -1));
      }
    } else if (amount === "0") {
      setAmount(value);
    } else {
      setAmount(amount + value);
    }
  };

  const handleCategoryClick = (c) => {
    if (category === c) {
      setCategory("");
    } else {
      setCategory(c);
    }
  };

  return (
    <div className="bg-gray-200 p-1">
      <div className="mx-0 w-full flex flex-wrap mt-3">
        {categories.map((c, index) => (
          <div
            key={index}
            onClick={() => handleCategoryClick(c)}
            className={`flex-auto items-center text-center m-1 p-2 pt-1 rounded-full cursor-pointer ${
              category === c
                ? "bg-gradient-to-l from-blue-400 to-blue-500"
                : "bg-gradient-to-r from-blue-200 to-blue-300"
            }`}
          >
            <span className="text-xs">{c}</span>
          </div>
        ))}
      </div>

      <div className="my-3 mx-12">
        <h3 className="w-full p-1 border-2 border-gray-300 rounded-md text-center min-h-[2rem] bg-white shadow-sm">
          {amount}
        </h3>
      </div>
      <div className="m-3 mx-12 grid grid-cols-3 gap-2">
        {[
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          ".",
          "0",
          "backspace",
        ].map((key) => (
          <button
            key={key}
            onClick={() => handleButtonClick(key)}
            className="p-2.5 bg-gradient-to-r from-blue-200 to-blue-300 rounded-full shadow-sm"
          >
            {key === "backspace" ? "⌫" : key}
          </button>
        ))}
      </div>
      <div className="my-3 mx-12">
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description (optional)"
          className="w-full p-1 border-2 border-gray-300 rounded-md bg-white shadow-sm"
        />
      </div>
      <div className="my-3 mx-12">
        <button
          onClick={addExpense}
          className="w-full p-2 pt-1 rounded-full text-white bg-blue-500 hover:bg-blue-600 shadow-lg"
        >
          Add Expense 💸
        </button> 
      </div>
    </div>
  );
};

export default AddExpense;
